import './basePath';
import 'ckeditor4';

// CKEditor 4 は contenteditable の要素を見つけるとインラインのエディタにするので、同じページの Tiptap の編集の領域を乗っ取らせない
CKEDITOR.disableAutoInline = true;

// ckeditor gem の CKEditor 4.7.1 は full プリセットだったので、同じプラグインを使う
// 外部のスペルチェックサービスを使う scayt と wsc（4.22 で無くなった）、非推奨になった flash は外す
const PLUGINS = [
  'dialogui',
  'dialog',
  'about',
  'a11yhelp',
  'dialogadvtab',
  'basicstyles',
  'bidi',
  'blockquote',
  'button',
  'toolbar',
  'notification',
  'clipboard',
  'panelbutton',
  'panel',
  'floatpanel',
  'colorbutton',
  'colordialog',
  'templates',
  'menu',
  'contextmenu',
  'copyformatting',
  'div',
  'resize',
  'elementspath',
  'enterkey',
  'entities',
  'popup',
  'filebrowser',
  'find',
  'fakeobjects',
  'floatingspace',
  'listblock',
  'richcombo',
  'font',
  'forms',
  'format',
  'horizontalrule',
  'htmlwriter',
  'iframe',
  'wysiwygarea',
  'image',
  'indent',
  'indentblock',
  'indentlist',
  'smiley',
  'justify',
  'menubutton',
  'language',
  'link',
  'list',
  'liststyle',
  'magicline',
  'maximize',
  'newpage',
  'pagebreak',
  'pastetext',
  'pastefromword',
  'preview',
  'print',
  'removeformat',
  'save',
  'selectall',
  'showblocks',
  'showborders',
  'sourcearea',
  'specialchar',
  'stylescombo',
  'tab',
  'table',
  'tabletools',
  'tableselection',
  'undo',
];

const CONFIG = {
  // 設定は JS で渡すので、CKEDITOR_BASEPATH の config.js は読まない
  customConfig: '',
  // 4.22 は古いバージョンだと「安全ではない」とエディタに通知するが、4.23 以降は有償の LTS 版なので出さない
  versionCheck: false,
  language: 'ja',
  plugins: PLUGINS.join(','),
  // サーバーのファイルブラウザは使わない
  filebrowserBrowseUrl: '',
  filebrowserImageBrowseLinkUrl: '',
  filebrowserImageBrowseUrl: '',
  // 4.17 からクリップボードの画像を Base64 のまま本文に入れるが、本文の文字数の上限や列の大きさを超えるので、画像はアップロードで入れてもらう
  clipboard_handleImages: false,
  allowedContent: true,
  toolbar: [
    {
      name: 'document',
      groups: ['mode', 'document', 'doctools'],
      items: ['Source'],
    },
    { name: 'links', items: ['Link', 'Unlink'] },
    { name: 'insert', items: ['Image'] },
    {
      name: 'paragraph',
      groups: ['list', 'align', 'bidi'],
      items: [
        'NumberedList',
        'BulletedList',
        '-',
        'JustifyLeft',
        'JustifyCenter',
        'JustifyRight',
        'JustifyBlock',
      ],
    },
    '/',
    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
    { name: 'colors', items: ['TextColor', 'BGColor'] },
    {
      name: 'basicstyles',
      groups: ['basicstyles', 'cleanup'],
      items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'],
    },
  ],
};

// 画像と添付ファイルの受け口はパスに事業者 ID が入るので、ビューで作った URL を受け取る
// XHR で送るので、Rails の CSRF のトークンをヘッダに付ける
export const replaceWithCKEditor = (
  element,
  { imageUploadUrl, fileUploadUrl },
) =>
  CKEDITOR.replace(element, {
    ...CONFIG,
    filebrowserImageUploadUrl: imageUploadUrl,
    filebrowserUploadUrl: fileUploadUrl,
    fileTools_requestHeaders: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
        ?.content,
    },
  });
